<template>
  <div>
    <label v-if="label || $slots.label" :for="name" class="input-label">
      <slot name="label" :required="required" :attrs-name="name"
        >{{ label }} <span v-if="required" class="required-input">*</span></slot
      >
    </label>
    <div class="relative flex items-center">
      <LoadingIcon v-if="toggling" class="h-6 w-6 text-blue" />
      <button
        v-else
        type="button"
        class="relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 element-focus"
        :class="{
          'bg-gray-200': !isChecked,
          'bg-green-500': isChecked,
          'opacity-50': disabled,
        }"
        role="switch"
        aria-checked="false"
        :disabled="disabled"
        @click="$refs.checkbox.click()"
      >
        <input
          ref="checkbox"
          v-model="value"
          type="checkbox"
          :disabled="disabled"
          :true-value="values[1]"
          :false-value="values[0]"
          class="hidden"
        />
        <span
          aria-hidden="true"
          class="pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow ring-0 transition ease-in-out duration-200"
          :class="{ 'translate-x-0': !isChecked, 'translate-x-5': isChecked }"
        />
      </button>
      <div class="ml-3 text-sm">
        <label class="font-medium text-gray-700"><slot /></label>
      </div>
    </div>
    <div
      v-if="displayedError"
      class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
    >
      <SolidExclamationCircleIcon class="h-5 w-5 text-red-500" />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useFieldValidation } from '@/api/useValidation'
export default {
  name: 'TSwitch',
  props: {
    name: {
      type: String,
      default: '',
    },
    validator: {
      type: String,
      default: 'validator',
    },
    label: {
      type: String,
      default: '',
    },
    modelValue: {
      type: [Number, Boolean, String, Array, Object],
      required: true,
    },
    values: {
      type: Array,
      default: () => [false, true],
    },
    error: {
      type: [String, Array],
      default: '',
    },
    help: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    toggling: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, context) {
    const value = computed({
      get() {
        return props.modelValue
      },
      set(value) {
        context.emit('update:modelValue', value)
      },
    })
    const isChecked = computed(() => props.modelValue === props.values[1])
    return {
      value,
      isChecked,
      ...useFieldValidation(props),
    }
  },
}
</script>
